import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './index.css';
import Text from '../../atoms/text';

const Success = (message?: string) =>
	toast.success(() => <Text className="leading-none">{message}</Text>);
const Warn = (message?: string) =>
	toast.warn(() => <Text className="leading-none">{message}</Text>);

export const NotificationToast = Object.assign(Success, {
	Success,
	Warn,
});

export const NotificationToastContainer = () => {
	return (
		<ToastContainer position="top-right" pauseOnFocusLoss hideProgressBar />
	);
};
